var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11, _path12, _path13, _path14, _path15, _path16, _path17, _path18, _path19, _path20, _path21, _path22, _path23, _path24, _path25, _path26;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEmptyStateNoSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 136,
    height: 109,
    viewBox: "0 0 136 109",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M79.6185 39.56C71.2385 39.61 62.7285 39.23 54.7685 37.01C46.8085 34.79 39.7685 30.63 33.3685 25.76C29.1785 22.59 25.3685 20.07 19.9285 20.45C14.6087 20.7338 9.52132 22.7217 5.4185 26.12C-1.5015 32.12 -0.451499 43.37 2.3085 51.26C6.4685 63.12 19.1285 71.37 29.8785 76.74C42.3085 82.94 55.9585 86.55 69.6485 88.62C81.6485 90.45 97.0485 91.77 107.449 83.94C116.999 76.74 119.618 60.3 117.278 49.21C116.711 45.9279 114.965 42.9658 112.368 40.88C105.658 35.98 95.6585 39.26 88.1185 39.42C85.3185 39.48 82.4785 39.55 79.6185 39.56Z",
    fill: "#3D3F63"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38.7583 0.75V5.06",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M36.6084 2.8999H40.9084",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M120.338 86.46V90.76",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M118.188 88.61H122.488",
    stroke: "#5E628C",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M6.26857 67.8899C6.80981 67.8899 7.24857 67.4512 7.24857 66.9099C7.24857 66.3687 6.80981 65.9299 6.26857 65.9299C5.72733 65.9299 5.28857 66.3687 5.28857 66.9099C5.28857 67.4512 5.72733 67.8899 6.26857 67.8899Z",
    fill: "#5E628C"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M89.7085 5.19999C90.2498 5.19999 90.6885 4.76123 90.6885 4.21999C90.6885 3.67875 90.2498 3.23999 89.7085 3.23999C89.1673 3.23999 88.7285 3.67875 88.7285 4.21999C88.7285 4.76123 89.1673 5.19999 89.7085 5.19999Z",
    fill: "#5E628C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M62.5486 108.06C82.8175 108.06 99.2486 107.039 99.2486 105.78C99.2486 104.521 82.8175 103.5 62.5486 103.5C42.2798 103.5 25.8486 104.521 25.8486 105.78C25.8486 107.039 42.2798 108.06 62.5486 108.06Z",
    fill: "#3D3F63"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M34.2782 12.4299H87.5782C88.9043 12.4299 90.1761 12.9567 91.1138 13.8944C92.0515 14.8321 92.5782 16.1039 92.5782 17.4299V80.8399C92.5782 82.166 92.0515 83.4378 91.1138 84.3755C90.1761 85.3131 88.9043 85.8399 87.5782 85.8399H27.4482C26.1222 85.8399 24.8504 85.3131 23.9127 84.3755C22.975 83.4378 22.4482 82.166 22.4482 80.8399V24.3799L34.2782 12.4299Z",
    fill: "#5E628C",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M92.3384 43.34H37.3784V86.46H92.3384V43.34Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M22.4482 24.3799H32.1382C32.4201 24.3799 32.6992 24.3243 32.9595 24.2161C33.2198 24.1079 33.4562 23.9494 33.655 23.7496C33.8538 23.5498 34.0113 23.3127 34.1182 23.0519C34.2252 22.7912 34.2796 22.5118 34.2782 22.2299V12.4299L22.4482 24.3799Z",
    fill: "#5E628C",
    stroke: "#3D3F63",
    strokeMiterlimit: 10
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0684 29.5599H37.7084C35.5932 29.5599 33.8784 31.2747 33.8784 33.3899V45.0199C33.8784 47.1352 35.5932 48.8499 37.7084 48.8499H92.0684C94.1837 48.8499 95.8984 47.1352 95.8984 45.0199V33.3899C95.8984 31.2747 94.1837 29.5599 92.0684 29.5599Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4386 42.5699C46.2833 42.5699 47.7786 41.0745 47.7786 39.2299C47.7786 37.3853 46.2833 35.8899 44.4386 35.8899C42.594 35.8899 41.0986 37.3853 41.0986 39.2299C41.0986 41.0745 42.594 42.5699 44.4386 42.5699Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9386 42.5699C56.7833 42.5699 58.2786 41.0745 58.2786 39.2299C58.2786 37.3853 56.7833 35.8899 54.9386 35.8899C53.094 35.8899 51.5986 37.3853 51.5986 39.2299C51.5986 41.0745 53.094 42.5699 54.9386 42.5699Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4284 42.5699C67.273 42.5699 68.7684 41.0745 68.7684 39.2299C68.7684 37.3853 67.273 35.8899 65.4284 35.8899C63.5837 35.8899 62.0884 37.3853 62.0884 39.2299C62.0884 41.0745 63.5837 42.5699 65.4284 42.5699Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0684 50.95H37.7084C35.5932 50.95 33.8784 52.6647 33.8784 54.7799V66.41C33.8784 68.5252 35.5932 70.24 37.7084 70.24H92.0684C94.1837 70.24 95.8984 68.5252 95.8984 66.41V54.7799C95.8984 52.6647 94.1837 50.95 92.0684 50.95Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4386 63.9599C46.2833 63.9599 47.7786 62.4645 47.7786 60.6199C47.7786 58.7753 46.2833 57.2799 44.4386 57.2799C42.594 57.2799 41.0986 58.7753 41.0986 60.6199C41.0986 62.4645 42.594 63.9599 44.4386 63.9599Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9386 63.9599C56.7833 63.9599 58.2786 62.4645 58.2786 60.6199C58.2786 58.7753 56.7833 57.2799 54.9386 57.2799C53.094 57.2799 51.5986 58.7753 51.5986 60.6199C51.5986 62.4645 53.094 63.9599 54.9386 63.9599Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4284 63.9599C67.273 63.9599 68.7684 62.4645 68.7684 60.6199C68.7684 58.7753 67.273 57.2799 65.4284 57.2799C63.5837 57.2799 62.0884 58.7753 62.0884 60.6199C62.0884 62.4645 63.5837 63.9599 65.4284 63.9599Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M92.0684 72.33H37.7084C35.5932 72.33 33.8784 74.0447 33.8784 76.16V87.79C33.8784 89.9052 35.5932 91.62 37.7084 91.62H92.0684C94.1837 91.62 95.8984 89.9052 95.8984 87.79V76.16C95.8984 74.0447 94.1837 72.33 92.0684 72.33Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M44.4386 85.3399C46.2833 85.3399 47.7786 83.8445 47.7786 81.9999C47.7786 80.1553 46.2833 78.6599 44.4386 78.6599C42.594 78.6599 41.0986 80.1553 41.0986 81.9999C41.0986 83.8445 42.594 85.3399 44.4386 85.3399Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9386 85.3399C56.7833 85.3399 58.2786 83.8445 58.2786 81.9999C58.2786 80.1553 56.7833 78.6599 54.9386 78.6599C53.094 78.6599 51.5986 80.1553 51.5986 81.9999C51.5986 83.8445 53.094 85.3399 54.9386 85.3399Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "M65.4284 85.3399C67.273 85.3399 68.7684 83.8445 68.7684 81.9999C68.7684 80.1553 67.273 78.6599 65.4284 78.6599C63.5837 78.6599 62.0884 80.1553 62.0884 81.9999C62.0884 83.8445 63.5837 85.3399 65.4284 85.3399Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M96.9883 53.92C108.437 53.92 117.718 44.6388 117.718 33.19C117.718 21.7411 108.437 12.46 96.9883 12.46C85.5394 12.46 76.2583 21.7411 76.2583 33.19C76.2583 44.6388 85.5394 53.92 96.9883 53.92Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M111.708 48.23L117.228 53.76",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })), _path26 || (_path26 = /*#__PURE__*/React.createElement("path", {
    d: "M116.602 51.08L114.889 52.8726C114.118 53.679 114.146 54.9577 114.953 55.7286L129.843 69.9634C130.65 70.7343 131.929 70.7055 132.699 69.8991L134.413 68.1064C135.184 67.3 135.155 66.0213 134.349 65.2504L119.458 51.0156C118.652 50.2447 117.373 50.2735 116.602 51.08Z",
    fill: "#3D3F63",
    stroke: "#5E628C",
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyStateNoSearch);
export default __webpack_public_path__ + "static/media/EmptyState-NoSearch.409b4dd131f43b85c9cad97fe408736b.svg";
export { ForwardRef as ReactComponent };